var migrate = require("./migrate");

var command = {
  command: 'deploy',
  description: '(alias for migrate)',
  builder: migrate.builder,
  run: migrate.run
}

module.exports = command;



//////////////////
// WEBPACK FOOTER
// ./packages/truffle-core/lib/commands/deploy.js
// module id = 1168
// module chunks = 0